// Hook to run an effect only once, when a condition is met

import { useEffect, useRef, DependencyList, EffectCallback } from 'react'

const useTriggerEffect = (callback: EffectCallback, dependencies: DependencyList, shouldTrigger: boolean): void => {
  const hasTriggered = useRef(false)

  useEffect(() => {
    // Reset the trigger flag if shouldTrigger is false
    if (!shouldTrigger) {
      hasTriggered.current = false
      return
    }

    // If it hasn't been triggered yet, run the callback and set the flag to true
    if (!hasTriggered.current) {
      callback()
      hasTriggered.current = true
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback, shouldTrigger, ...dependencies])
}

export default useTriggerEffect